import Obfuscate from "react-obfuscate"
import styled from "styled-components"
import { linkStyles } from "../Link"

export const ObfuscatedLink = styled(Obfuscate)`
  ${linkStyles}
`
